import { PropertyStyleActionTypes } from './constants';

const INIT_STATE = {
    data: null,
    loading: false,
    error: null,
    updateSuccess: null,
};

const PropertyStyle = (state = INIT_STATE, action) => {
    switch (action.type) {
        case PropertyStyleActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case PropertyStyleActionTypes.GET_PROPERTY_STYLES: {
                    return { ...state, data: action.payload.data.results, loading: false };
                }
                case PropertyStyleActionTypes.GET_PROPERTY_STYLE_BY_ID: {
                    return { ...state, data: action.payload.data, loading: false };
                }
                case PropertyStyleActionTypes.CREATE_PROPERTY_STYLE: {
                    return { ...state, data: action.payload.data, loading: false, updateSuccess: true };
                }
                case PropertyStyleActionTypes.UPDATE_PROPERTY_STYLE: {
                    return {
                        ...state,
                        id: action.payload.id,
                        data: action.payload.data,
                        loading: false,
                        updateSuccess: true,
                    };
                }
                default:
                    return { ...state };
            }
        case PropertyStyleActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case PropertyStyleActionTypes.GET_PROPERTY_STYLES: {
                    return { ...state, error: action.payload, loading: false };
                }
                case PropertyStyleActionTypes.GET_PROPERTY_STYLE_BY_ID: {
                    return { ...state, error: action.payload, loading: false };
                }
                case PropertyStyleActionTypes.CREATE_PROPERTY_STYLE: {
                    return { ...state, error: action.payload, loading: false, updateSuccess: false };
                }
                case PropertyStyleActionTypes.UPDATE_PROPERTY_STYLE: {
                    return { ...state, error: action.payload, loading: false, updateSuccess: false };
                }
                default:
                    return { ...state };
            }
        case PropertyStyleActionTypes.GET_PROPERTY_STYLES:
            return { ...state, loading: true };
        case PropertyStyleActionTypes.GET_PROPERTY_STYLE_BY_ID:
            return { ...state, data: null, loading: true };
        case PropertyStyleActionTypes.CREATE_PROPERTY_STYLE:
            return {
                ...state,
                data: action.payload.data,
                loading: true,
            };
        case PropertyStyleActionTypes.UPDATE_PROPERTY_STYLE: {
            return {
                ...state,
                id: action.payload.id,
                data: action.payload.data,
                loading: false,
            };
        }
        default:
            return { ...state, updateSuccess: null };
    }
};

export default PropertyStyle;
